// The last line of defence against a BLANK PAGE. React 18 unmounts the whole
// tree when a render throws and nothing catches it — which is exactly what KS
// saw on the Contractors Report on 2026-09-08 ("enter a contractor & screen
// goes blank"): a filter handler read `e.target.value` off a plain value
// inside a state updater, the updater ran during the next render, and the
// app vanished with nothing in the Error Log to say why. This boundary keeps
// the page, says what happened, offers a reload, and records the crash
// through the same error-log channel every other failure uses, so the next
// one is a log entry with a stack rather than a chat message.
import React from "react";
import { Alert, Button } from "react-bootstrap";
import { reportError } from "../../services/apiClient.js";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    reportError(error, {
      action: "render",
      message: `Page crashed: ${error?.message || "unknown error"}`,
      detail: [error?.stack, info?.componentStack].filter(Boolean).join("\n"),
    });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="container py-5" style={{ maxWidth: 640 }}>
        <Alert variant="danger">
          <div className="fw-semibold mb-1">This page hit an error and could not be drawn.</div>
          <div className="small mb-3">
            It has been recorded in the Error Log. Reloading usually brings the page back; if it keeps
            happening, tell Robert which page and what you clicked.
          </div>
          <div className="small text-muted mb-3" style={{ whiteSpace: "pre-wrap" }}>{String(this.state.error?.message || "")}</div>
          <Button size="sm" onClick={() => window.location.reload()}>Reload</Button>{" "}
          <Button size="sm" variant="outline-secondary" onClick={() => { window.location.href = "/"; }}>Home</Button>
        </Alert>
      </div>
    );
  }
}

export default AppErrorBoundary;
